import Splide from '@splidejs/splide';

// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Work slider
     */

    const splideWorkSlider = document.querySelectorAll('.splide[data-slider="work"]');

    const splideWorkTotal = document.querySelectorAll('.splide[data-slider="work"] .splide__slide').length;
    const splideWorkRand = Math.floor(Math.random() * splideWorkTotal); 

    splideWorkSlider.forEach(function(sliderElement) {

        const slider = new Splide(sliderElement, {
            type: 'loop',
            rewind: true,
            gap: '80px',
            perPage: 3,
            drag: 'free',
            snap: true,
            mediaQuery: 'max',
            // start: splideWorkRand,
            autoplay: false,
            interval: 4000,
            speed: 2000,
            pauseOnHover: true,
            pagination: false,
            arrowPath: 'M0,17.5h30.4l-14-14L20,0l20,20L20,40l-3.5-3.5l13.9-14H0V17.5z',
            breakpoints: {
                1100: {
                    gap: '60px',
                },
                800: {
                    perPage: 2,
                    gap: '40px',
                },
                600: {
                    perPage: 1,
                    gap: '20px',
                    padding: '40px',
                },
            }
        });
        slider.mount();

        if(splideWorkTotal < 2) {
            slider.options = {
                pagination: false,
                arrows: false,
           };
        }
    });

    /**
     * Testimonials slider
     */

    const splideTestimonialSlider = document.querySelectorAll('.splide[data-slider="testimonials"]');

    const splideTestimonialTotal = document.querySelectorAll('.splide[data-slider="testimonials"] .splide__slide').length;
    const splideTestimonialRand = Math.floor(Math.random() * splideTestimonialTotal); 

    splideTestimonialSlider.forEach(function(sliderElement) {

        const slider = new Splide(sliderElement, {
            type: 'slide',
            rewind: true,
            gap: '80px',
            perPage: 2,
            perMove: 1,
            drag: 'free',
            snap: true,
            mediaQuery: 'max',
            // start: splideTestimonialRand,
            autoplay: false,
            interval: 4000,
            speed: 2000,
            pauseOnHover: true,
            pagination: false,
            arrowPath: 'M0,17.5h30.4l-14-14L20,0l20,20L20,40l-3.5-3.5l13.9-14H0V17.5z',
            breakpoints: {
                1100: {
                    gap: '60px',
                },
                800: {
                    gap: '40px',
                    perPage: 1,
                },
                600: {
                    gap: '20px',
                    padding: '40px',
                },
            }
        });
        slider.mount();

        if(splideTestimonialTotal < 3) {
            slider.options = {
                pagination: false,
                arrows: false,
           };
        }
    });

});